var _defs, _path, _path2, _path3, _polygon, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _circle2, _path12, _path13, _path14, _path15, _path16, _circle3, _path17, _path18, _ellipse, _ellipse2, _g2, _circle4, _path19, _circle5, _path20, _path21, _path22, _circle6, _path23, _path24, _path25, _path26, _ellipse3, _ellipse4, _g3, _circle7, _path27, _path28, _circle8, _path29, _path30, _path31, _circle9, _path32, _ellipse5, _ellipse6, _path33, _path34, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path35, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path36, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a6a3afa7-c5e3-4bb7-8d5f-b359f5b682fe",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 731.88699 786.02085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b46bd2fb-1dd7-45a7-b93b-1bb03e6f815a",
    x1: 304.00941,
    y1: 181.7169,
    x2: 304.00941,
    y2: 30.6652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e4df816c-b603-4657-99aa-98828b41fd59",
    x1: 623.86313,
    y1: 187.10404,
    x2: 623.86313,
    y2: 36.05235,
    xlinkHref: "#b46bd2fb-1dd7-45a7-b93b-1bb03e6f815a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc9a51cc-fc1f-46c2-8ec5-d2020d62cbce",
    x1: 463.94546,
    y1: 311.01376,
    x2: 463.94546,
    y2: 159.96207,
    xlinkHref: "#b46bd2fb-1dd7-45a7-b93b-1bb03e6f815a"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Connecting Teams") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M369.06644,190.68739,398.40208,159.885s32.26922-48.40382,55.73773-35.20278-33.736,44.00348-33.736,44.00348l-29.33565,48.40381Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#a0616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276.65915,787.66781s-22.00174,42.53668-5.86713,45.47025,95.34085,7.33391,96.80764,2.93356,13.201-19.06817,4.40034-24.9353-44.00347-10.26747-44.00347-10.26747l-11.73426-11.73426Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264.92489,372.5684s-46.937,58.6713-8.80069,118.80937l8.80069,101.208s-16.1346,139.34433,4.40035,186.28136l2.93356,16.13461h51.33738L310.39514,671.792s1.46679-14.66782,5.86713-17.60139S392.535,492.84455,392.535,492.84455s-11.73426-22.00173-7.33392-26.40208-4.40034-92.40729-8.80069-95.34085S264.92489,372.5684,264.92489,372.5684Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "114.475 717.477 120.342 751.213 63.138 748.28 70.472 711.61 114.475 717.477",
    fill: "#a0616a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104.2075,
    cy: 75.02652,
    r: 44.00347,
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M298.66089,139.35l-4.40035,52.80416,46.937,22.00174s-8.0673-49.13721-2.20017-62.33825Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#a0616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M347.0647,211.22234,342.66436,193.621l-60.13808-22.00174s-5.86713,0-4.40035,10.26748,1.46678,8.80069,1.46678,8.80069-20.535,8.80069-22.00173,23.46852-24.9353,19.06817-23.46852,41.0699,8.8007,33.736,8.8007,33.736-7.33392,17.60139,4.40034,27.86886c0,0,11.73426,20.535,5.86713,35.20278s-13.201,39.60312,2.93357,35.20278S383.73426,375.502,383.73426,375.502s16.13461-60.13808-1.46678-82.13982c0,0,0-13.201-13.201-39.60312S347.0647,211.22234,347.0647,211.22234Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#575a89"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M269.32524,376.96875s19.06817,80.673,42.53669,89.47372c0,0,4.40034,58.6713,29.33564,55.73773s0-55.73773,0-55.73773l-27.86886-101.208Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M344.13114,215.62269S366.13287,180.41991,372,186.287s35.20278,23.46852,33.736,35.20278-14.66783,11.73426-14.66783,11.73426L360.26574,256.6926Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#575a89"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M374.93357,478.17673,392.535,490.82917l11.73425,125.2251S361.73253,786.201,349.99827,787.66781s-60.13808,1.46678-58.6713-2.93357,8.8007-22.00173,8.8007-26.40208,15.29776-39.5908,15.29776-39.5908l19.905-82.15214L330.9301,572.0508Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M352.93183,796.4685s-61.60486-19.06817-64.53842-14.66782-22.50087,48.7503,4.88417,53.71079,125.65946,13.76119,125.65946.56015-2.93357-22.00173-11.73426-22.00173S358.799,795.00172,355.8654,790.60137,352.93183,796.4685,352.93183,796.4685Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M296.53952,134.90847c-1.83191-3.76994,2.22928-7.87317,5.87631-5.80736l.07748.04457a7.61186,7.61186,0,0,1,3.57891,7.61048c5.28948-5.27773,1.39122-15.86188,7.10635-20.67543,2.64531-2.228,6.93939-2.71817,8.29835-5.89858.79114-1.85154.25325-4.04617.95063-5.935,1.03554-2.80472,4.34379-3.97593,7.30088-4.41691,9.29931-1.38675,18.70391.973,27.80984,3.31446,3.3483.86095,6.869,1.81767,9.30789,4.268,2.56875,2.58089,3.46256,6.33092,5.03769,9.614s11.90577,2.98635,15.51737,2.52178c1.25556-3.56645-8.01727-3.83534-8.77422-7.53979-2.06894-10.12527,5.136-20.89217,1.60141-30.60341-2.12982-5.85171-7.69356-9.72531-13.295-12.446a70.56425,70.56425,0,0,0-49.92782-4.2605,11.08587,11.08587,0,0,0-4.61124,2.22963c-2.13171,1.9901-2.5269,5.18534-3.94659,7.73272-3.23472,5.80413-10.90634,7.18359-16.0793,11.35393-7.83444,6.316-8.71768,17.72032-8.97135,27.78041-.12775,5.06629-.2179,10.33061,1.8572,14.9542s6.99252,8.39106,11.967,7.42261C296.98585,135.78974,296.75994,135.36208,296.53952,134.90847Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M304.19252,229.916a31.25207,31.25207,0,0,0-38.14826,1.93864c-10.109,8.59045-20.9838,20.89842-20.18754,33.63864,1.46678,23.46852,10.26748,120.27615,22.00174,121.74294s54.27094-10.26748,54.27094-17.60139-10.26747-16.13461-10.26747-16.13461l12.46655-74.7993c3.08067-18.484-4.26974-37.36865-19.47785-48.31684Q304.52393,230.14891,304.19252,229.916Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#575a89"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 304.00941,
    cy: 106.19105,
    r: 75.52585,
    fill: "url(#b46bd2fb-1dd7-45a7-b93b-1bb03e6f815a)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.15619,
    cy: 105.70843,
    r: 73.9337,
    fill: "#f5f5f5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M578.88516,169.98383c0,24.59329-17.67074,36.69609-40.61309,36.69609s-42.46851-12.1028-42.46851-36.69609,18.59845-44.53009,41.5408-44.53009S578.88516,145.39054,578.88516,169.98383Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M538.27208,236.9236A73.5882,73.5882,0,0,0,578.91165,224.762c-2.72424-14.8884-13.09153-15.73737-13.09153-15.73737H508.65487s-9.78332.80331-12.83919,14.49937A73.59315,73.59315,0,0,0,538.27208,236.9236Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#455a64"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M291.92288,133.87387H314.789a0,0,0,0,1,0,0V152.8043a10.79548,10.79548,0,0,1-10.79548,10.79548h-1.27513a10.79548,10.79548,0,0,1-10.79548-10.79548V133.87387A0,0,0,0,1,291.92288,133.87387Z",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M293.98245,133.027h18.74694a2.05958,2.05958,0,0,1,2.05958,2.05958v16.87086a10.79548,10.79548,0,0,1-10.79548,10.79548h-1.27513a10.79548,10.79548,0,0,1-10.79548-10.79548V135.08655a2.05958,2.05958,0,0,1,2.05958-2.05958Z",
    fill: "#fda57d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M526.02173,199.49749a32.90921,32.90921,0,0,0,22.86609.0632v-2.80893H526.02173Z",
    transform: "translate(-234.0565 -56.98958)",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.44061,
    cy: 111.26426,
    r: 32.77473,
    fill: "#fda57d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M499.72056,170.39615s20.40963-2.4739,35.87146-22.26505c0,0,20.40963,22.47121,34.63452,19.99731,0,0,8.24631-8.65863,0-17.31725s-14.63721-19.585-25.56357-18.14189-24.32663,2.06158-30.099,7.21552S499.72056,170.39615,499.72056,170.39615Z",
    transform: "translate(-234.0565 -56.98958)",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M499.72056,169.98383s20.40963-2.47389,35.87146-22.265c0,0,20.40963,22.4712,34.63452,19.99731,0,0,8.24631-8.65863,0-17.31726s-14.63721-19.585-25.56357-18.14189-24.32663,2.06158-30.099,7.21553S499.72056,169.98383,499.72056,169.98383Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.65284,
    cy: 111.23304,
    rx: 3.04881,
    ry: 5.71652,
    fill: "#fda57d"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.21102,
    cy: 111.23304,
    rx: 3.04881,
    ry: 5.71652,
    fill: "#fda57d"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 623.86313,
    cy: 111.57819,
    r: 75.52585,
    fill: "url(#e4df816c-b603-4657-99aa-98828b41fd59)"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.00991,
    cy: 111.09558,
    r: 73.9337,
    fill: "#f5f5f5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M858.1258,242.31074a73.5882,73.5882,0,0,0,40.63957-12.1616c-2.72424-14.88841-13.09152-15.73738-13.09152-15.73738H828.50859s-9.78331.80332-12.83919,14.49938A73.59321,73.59321,0,0,0,858.1258,242.31074Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#455a64"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.29433,
    cy: 109.53751,
    r: 35.6862,
    fill: "#72351c"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M611.7766,139.261h22.86609a0,0,0,0,1,0,0v18.93044a10.79548,10.79548,0,0,1-10.79548,10.79548h-1.27513a10.79548,10.79548,0,0,1-10.79548-10.79548V139.261A0,0,0,0,1,611.7766,139.261Z",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M613.83618,138.41412h18.74694a2.05958,2.05958,0,0,1,2.05958,2.05958v16.87086A10.79548,10.79548,0,0,1,623.84721,168.14h-1.27513a10.79548,10.79548,0,0,1-10.79548-10.79548V140.4737a2.05958,2.05958,0,0,1,2.05958-2.05958Z",
    fill: "#fda57d"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M845.87545,204.88463a32.90914,32.90914,0,0,0,22.86609.06321v-2.80893H845.87545Z",
    transform: "translate(-234.0565 -56.98958)",
    opacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.29433,
    cy: 116.65141,
    r: 32.77473,
    fill: "#fda57d"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M834.00533,143.82883s13.81257,28.03747,52.7764,11.751l-9.07094-14.22489-16.08031-5.77242Z",
    transform: "translate(-234.0565 -56.98958)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M834.00533,143.41652s13.81257,28.03746,52.7764,11.751l-9.07094-14.22489-16.08031-5.77242Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#72351c"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M833.88268,141.52232a18.93353,18.93353,0,0,1,4.69286-7.63321c6.44777-6.37257,17.01537-7.718,22.43633-14.98418a4.24338,4.24338,0,0,1-1.94351,5.98413c5.18682-.03364,11.21305-.48821,14.14838-4.76465a9.71442,9.71442,0,0,1-1.63823,10.25821c4.60347.209,9.51528,3.33315,9.81282,7.93175.19823,3.06361-1.72272,5.96424-4.24028,7.7212a23.57019,23.57019,0,0,1-8.56149,3.22454C859.83806,151.18963,828.17205,159.277,833.88268,141.52232Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#72351c"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M890.12455,173.92787h-.86892l-16.90495,15.04952c-16.28646-7.62783-28.24362,0-28.24362,0l-17.72957-14.431-1.78772.22463a32.77394,32.77394,0,0,0,65.53478-.84311Zm-32.82339,20.82194c-6.376,0-11.54484-1.29221-11.54484-2.88621s5.16881-2.88621,11.54484-2.88621,11.54484,1.29222,11.54484,2.88621S863.67719,194.74981,857.30116,194.74981Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#72351c"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 590.50656,
    cy: 116.62018,
    rx: 3.04881,
    ry: 5.71652,
    fill: "#fda57d"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.06474,
    cy: 116.62018,
    rx: 3.04881,
    ry: 5.71652,
    fill: "#fda57d"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 463.94546,
    cy: 235.48791,
    r: 75.52585,
    fill: "url(#bc9a51cc-fc1f-46c2-8ec5-d2020d62cbce)"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 463.94546,
    cy: 235.0756,
    r: 73.9337,
    fill: "#f5f5f5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M669.147,292.72342s-8.38423,41.29544-12.95745,39.00883c0,0,44.12309,38.11015,83.08013,0,0,0-6.85982-29.10019-16.76846-39.00883Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#333"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M698.20813,366.22046a73.58825,73.58825,0,0,0,40.63957-12.1616c-2.72425-14.88841-13.09153-15.73737-13.09153-15.73737H668.59091s-9.78331.80331-12.83919,14.49937A73.59324,73.59324,0,0,0,698.20813,366.22046Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#455a64"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 463.37666,
    cy: 233.44723,
    r: 32.77473,
    fill: "#333"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M451.85892,263.17073H474.725a0,0,0,0,1,0,0v18.93044a10.79548,10.79548,0,0,1-10.79548,10.79548h-1.27513a10.79548,10.79548,0,0,1-10.79548-10.79548V263.17073a0,0,0,0,1,0,0Z",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M453.9185,262.32384h18.74694a2.05958,2.05958,0,0,1,2.05958,2.05958v16.87086a10.79548,10.79548,0,0,1-10.79548,10.79548h-1.27513a10.79548,10.79548,0,0,1-10.79548-10.79548V264.38342a2.05958,2.05958,0,0,1,2.05958-2.05958Z",
    fill: "#be7c5e"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M685.95777,328.79435a32.90916,32.90916,0,0,0,22.8661.06321v-2.80893h-22.8661Z",
    transform: "translate(-234.0565 -56.98958)",
    opacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 463.37666,
    cy: 240.56113,
    r: 32.77473,
    fill: "#be7c5e"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M666.09815,285.10139H728.5988s-5.33542-25.23739-28.96372-23.6283S666.09815,285.10139,666.09815,285.10139Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#333"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 431.27944,
    cy: 239.16376,
    rx: 3.04881,
    ry: 5.71652,
    fill: "#be7c5e"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 495.3045,
    cy: 239.16376,
    rx: 3.04881,
    ry: 5.71652,
    fill: "#be7c5e"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M666.09815,285.94828H728.5988s-5.33542-25.23739-28.96372-23.6283S666.09815,285.94828,666.09815,285.94828Z",
    transform: "translate(-234.0565 -56.98958)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M698.002,223.63878a68.83874,68.83874,0,1,1-68.83874,68.8387,68.83869,68.83869,0,0,1,68.83874-68.8387m0-17a85.83874,85.83874,0,1,0,85.83875,85.8387,85.93591,85.93591,0,0,0-85.83875-85.8387Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 451.23677,
    y: 129.58217,
    width: 20.12209,
    height: 21.18115,
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 733.87984,
    y: 199.35176,
    width: 21.18115,
    height: 20.12209,
    transform: "translate(-52.51851 682.70335) rotate(-59)",
    fill: "#ccc"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 769.18659,
    y: 233.71454,
    width: 21.18115,
    height: 20.12209,
    transform: "translate(-254.47257 351.61855) rotate(-29)",
    fill: "#ccc"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 770.18196,
    y: 329.79797,
    width: 20.12209,
    height: 21.18115,
    transform: "translate(-155.94515 764.70412) rotate(-58)",
    fill: "#ccc"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 606.16572,
    y: 233.18501,
    width: 20.12209,
    height: 21.18115,
    transform: "translate(-129.79334 607.56533) rotate(-61)",
    fill: "#ccc"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 605.17034,
    y: 330.3275,
    width: 21.18115,
    height: 20.12209,
    transform: "translate(-320.86891 321.03668) rotate(-32)",
    fill: "#ccc"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 641.47247,
    y: 198.82223,
    width: 20.12209,
    height: 21.18115,
    transform: "translate(-248.85178 308.48599) rotate(-31)",
    fill: "#ccc"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 451.23677,
    y: 320.21251,
    width: 20.12209,
    height: 21.18115,
    fill: "#ccc"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 734.40937,
    y: 364.9516,
    width: 20.12209,
    height: 21.18115,
    transform: "translate(-321.14031 380.08073) rotate(-31)",
    fill: "#ccc"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 640.94294,
    y: 365.48113,
    width: 21.18115,
    height: 20.12209,
    transform: "translate(-239.99003 683.6073) rotate(-59)",
    fill: "#ccc"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 355.9216,
    y: 227.01546,
    width: 24.35832,
    height: 18.00398,
    fill: "#ccc"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 781.6675,
    y: 284.00503,
    width: 24.35832,
    height: 18.00398,
    transform: "translate(1353.63682 529.02446) rotate(-180)",
    fill: "#ccc"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M857.91962,99.729a68.83874,68.83874,0,1,1-68.83869,68.83877A68.83875,68.83875,0,0,1,857.91962,99.729m0-17a85.83874,85.83874,0,1,0,85.83874,85.83877A85.93592,85.93592,0,0,0,857.91962,82.729Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#ccc"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 611.15444,
    y: 5.67245,
    width: 20.12209,
    height: 21.18115,
    fill: "#ccc"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 893.79751,
    y: 75.44204,
    width: 21.18115,
    height: 20.12209,
    transform: "translate(131.24683 759.68806) rotate(-59)",
    fill: "#ccc"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 929.10426,
    y: 109.80482,
    width: 21.18115,
    height: 20.12209,
    transform: "translate(-174.34942 413.61234) rotate(-29)",
    fill: "#ccc"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 930.09964,
    y: 205.88825,
    width: 20.12209,
    height: 21.18115,
    transform: "translate(24.31047 842.07442) rotate(-58)",
    fill: "#ccc"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 766.08339,
    y: 109.27529,
    width: 20.12209,
    height: 21.18115,
    transform: "translate(60.96859 683.59539) rotate(-61)",
    fill: "#ccc"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 765.08801,
    y: 206.41777,
    width: 21.18115,
    height: 20.12209,
    transform: "translate(-230.90696 386.95182) rotate(-32)",
    fill: "#ccc"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 801.39014,
    y: 74.91251,
    width: 20.12209,
    height: 21.18115,
    transform: "translate(-162.19209 373.15132) rotate(-31)",
    fill: "#ccc"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 611.15444,
    y: 196.30279,
    width: 20.12209,
    height: 21.18115,
    fill: "#ccc"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 894.32704,
    y: 241.04188,
    width: 20.12209,
    height: 21.18115,
    transform: "matrix(0.85717, -0.51504, 0.51504, 0.85717, -234.48061, 444.74606)",
    fill: "#ccc"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 800.86061,
    y: 241.57141,
    width: 21.18115,
    height: 20.12209,
    transform: "translate(-56.22469 760.59201) rotate(-59)",
    fill: "#ccc"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 515.83927,
    y: 103.10573,
    width: 24.35832,
    height: 18.00398,
    fill: "#ccc"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 941.58517,
    y: 160.09531,
    width: 24.35832,
    height: 18.00398,
    transform: "translate(1673.47217 281.20502) rotate(-180)",
    fill: "#ccc"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M538.041,94.433q1.21215,0,2.43158.04225A68.83915,68.83915,0,0,1,538.1275,232.112q-1.21224,0-2.43152-.04225A68.83915,68.83915,0,0,1,538.041,94.433m.00506-17v17l-.00134-17a85.83915,85.83915,0,0,0-2.93854,171.6266c1.00385.03482,2.0202.05245,3.02124.05245a85.83913,85.83913,0,0,0,2.93494-171.62657c-1.00385-.03483-2.01856-.05248-3.0163-.05248Z",
    transform: "translate(-234.0565 -56.98958)",
    fill: "#ccc"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 528.15457,
    y: 57.86179,
    width: 21.18115,
    height: 20.12209,
    transform: "translate(218.11525 546.99752) rotate(-88.01176)",
    fill: "#ccc"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 576.81607,
    y: 71.80896,
    width: 21.18115,
    height: 20.12209,
    transform: "matrix(0.54447, -0.83878, 0.83878, 0.54447, -35.14445, 473.01122)",
    fill: "#ccc"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 610.90936,
    y: 107.376,
    width: 21.18115,
    height: 20.12209,
    transform: "translate(-219.59592 238.08994) rotate(-27.01176)",
    fill: "#ccc"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 608.55253,
    y: 203.41742,
    width: 20.12209,
    height: 21.18115,
    transform: "translate(-138.70722 550.30796) rotate(-56.01176)",
    fill: "#ccc"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 447.98696,
    y: 101.17218,
    width: 20.12209,
    height: 21.18115,
    transform: "translate(-107.65128 389.90294) rotate(-59.01176)",
    fill: "#ccc"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 443.63993,
    y: 198.24034,
    width: 21.18115,
    height: 20.12209,
    transform: "translate(-277.34225 198.13487) rotate(-30.01176)",
    fill: "#ccc"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 484.46465,
    y: 68.05504,
    width: 20.12209,
    height: 21.18115,
    transform: "translate(-210.14578 192.71843) rotate(-29.01176)",
    fill: "#ccc"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 521.54076,
    y: 248.37737,
    width: 21.18115,
    height: 20.12209,
    transform: "translate(21.33003 724.29345) rotate(-88.01176)",
    fill: "#ccc"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 571.58184,
    y: 237.30878,
    width: 20.12209,
    height: 21.18115,
    transform: "translate(-281.30055 256.20724) rotate(-29.01176)",
    fill: "#ccc"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 478.17136,
    y: 234.61392,
    width: 21.18115,
    height: 20.12209,
    transform: "translate(-216.63831 464.43284) rotate(-57.01176)",
    fill: "#ccc"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 430.09976,
    y: 151.47443,
    width: 24.35832,
    height: 18.00398,
    transform: "translate(-228.22261 -72.23757) rotate(1.98824)",
    fill: "#ccc"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 621.67375,
    y: 158.12498,
    width: 24.35832,
    height: 18.00398,
    transform: "translate(1027.46935 299.15489) rotate(-178.01176)",
    fill: "#ccc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.79ba8a87.svg";
export { ForwardRef as ReactComponent };